module.exports = __webpack_public_path__ + "img/cart-4.1c40861f.svg";